// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/hooks/useCrmDashboard.ts
// ════════════════════════════════════════════════════════════════════════════

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { crmDashboardService, type FiltrosCrmDashboard } from '../services/crmDashboardService';

export const useCrmDashboard = (mesesEvolucao = 12, diasAtraso = 1, filtros: FiltrosCrmDashboard = {}) =>
  useQuery({
    queryKey: ['crm', 'dashboard', mesesEvolucao, diasAtraso, filtros],
    queryFn:  () => crmDashboardService.obter(mesesEvolucao, diasAtraso, filtros),
    // Trocar filtro mantém a tela (e a barra de filtros) enquanto recarrega.
    placeholderData: keepPreviousData,
  });

export const useCrmAlertas = (diasAtraso = 1) =>
  useQuery({
    queryKey: ['crm', 'dashboard', 'alertas', diasAtraso],
    queryFn:  () => crmDashboardService.listarAlertas(diasAtraso),
    refetchInterval: 60_000,
  });
